/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import '@scuf/common/honeywell-combined/theme.css';
import '@scuf/datatable/honeywell-combined/theme.css';
import './index.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import {
  AppProvider,
  Authenticate,
  ErrorPage,
  Login,
  RequestPasswordReset,
  ResetPassword,
} from '@keystone/common';
import Nav from './partials/Nav';
import Footer from './partials/Footer';
import PrivateRoute from './partials/PrivateRoute';
import ViewUsers from './pages/user/ViewUsers';
import ViewOperators from './pages/operator/ViewOperators';
import ManageOperatorTemplates from './pages/operator/ManageOperatorTemplates';
import Routes from './common/routes';
import OperatorProvider from './pages/operator/OperatorContext';
import UserProvider from './pages/user/UserContext';
import DeviceInfoProvider from './pages/deviceinfo/DeviceInfoContext';
import DeviceInfo from './pages/deviceinfo/DisplayDeviceInfo';
import ViewLicense from './pages/license/viewLicense';
import DeviceConfig from './pages/deviceConfig/deviceConfig';
import ThirdPartyLicense from './pages/ThirdPartyLicense/thirdPartyLicense';
import SiteProvider from './pages/site/SiteContext';
import ViewSites from './pages/site/ViewSites';
import DeviceLogsProvider from './pages/devicelogs/DeviceLogsContext';
import DeviceLogs from './pages/devicelogs/DisplayDeviceLogs';
import { CustomerSiteProvider } from './common/CustomerSiteContext';
import UserPreferences from './pages/UserPreferences';

const LoginContainer = () => (
  <Route
    exact
    path={Routes.Login}
    render={(props) => <Login {...props} destination={Routes.Users} />}
  />
);

const DefaultContainer = () => (
  <>
    <Nav>
      <Switch>
        <PrivateRoute exact path={Routes.Home} component={ViewUsers} />
        <PrivateRoute exact path={Routes.Users} component={ViewUsers} />
        <PrivateRoute exact path={Routes.Operators} component={ViewOperators} />
        <PrivateRoute
          exact
          path={Routes.ManageOperatorTemplates}
          component={ManageOperatorTemplates}
        />
        <PrivateRoute exact path={Routes.DeviceInfo} component={DeviceInfo} />
        <PrivateRoute exact path={Routes.ViewLicense} component={ViewLicense} />
        <PrivateRoute exact path={Routes.DeviceConfig} component={DeviceConfig} />
        <PrivateRoute exact path={Routes.ThirdPartyLicense} component={ThirdPartyLicense} />
        <PrivateRoute exact path={Routes.Sites} component={ViewSites} />
        <PrivateRoute exact path={Routes.DeviceLogs} component={DeviceLogs} />
        <PrivateRoute exact path={Routes.UserPreferences} component={UserPreferences} />
        <Route path="/*" render={() => <Redirect to="/login" />} />
      </Switch>
    </Nav>
    <Footer />
  </>
);

ReactDOM.render(
  <AppProvider>
    <CustomerSiteProvider>
      <DeviceLogsProvider>
        <SiteProvider>
          <DeviceInfoProvider>
            <OperatorProvider>
              <UserProvider>
                {/**
                 *  Use react-router to handle our application routing.  See: https://reacttraining.com/react-router/
                 *  for further details.
                 */}
                <Router>
                  <Switch>
                    <Route exact path={Routes.Login} component={LoginContainer} />
                    <Route
                      exact
                      path={Routes.RequestPasswordReset}
                      component={RequestPasswordReset}
                    />
                    <Route exact path={Routes.ResetPassword} component={ResetPassword} />
                    <Route
                      path="/callback"
                      render={(props) => <Authenticate {...props} destination={Routes.Users} />}
                    />
                    <Route
                      path="/*/callback"
                      render={(props) => <Authenticate {...props} destination={Routes.Users} />}
                    />
                    <Route path={Routes.Error} component={ErrorPage} />
                    <Route component={DefaultContainer} />
                  </Switch>
                </Router>
              </UserProvider>
            </OperatorProvider>
          </DeviceInfoProvider>
        </SiteProvider>
      </DeviceLogsProvider>
    </CustomerSiteProvider>
  </AppProvider>,

  document.getElementById('root')
);
